import React from 'react';
import { TranslateContextProvider } from './TranslateContext';
export const TranslateProvider = ({ translations, children }) => (React.createElement(TranslateContextProvider, { value: {
        translations,
    } }, children));
//# sourceMappingURL=TranslateProvider.js.map